import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { NotifyService } from '@dash/randy/shared/service/notify.service';
import { ErrorReporterService } from './error-reporter.service';

const ERROR_NOTIFICATION_COOLDOWN_MS = 10 * 60 * 1_000;

@Injectable()
export class RandyErrorHandler implements ErrorHandler {
  private lastNotificationAt = 0;

  constructor(
    private readonly errorReporter: ErrorReporterService,
    private readonly notifyService: NotifyService,
  ) {}

  handleError(error: unknown): void {
    const originalError = unwrapAngularError(error);
    console.error(originalError);

    if (originalError instanceof HttpErrorResponse) {
      return;
    }

    const eventId = this.errorReporter.capture(originalError, {
      source: 'angular-error-handler',
    });
    if (!eventId || Date.now() - this.lastNotificationAt < ERROR_NOTIFICATION_COOLDOWN_MS) {
      return;
    }

    this.lastNotificationAt = Date.now();
    this.notifyService.notifyUnexpectedError(originalError, eventId);
  }
}

function unwrapAngularError(error: unknown): unknown {
  if (error && typeof error === 'object' && 'ngOriginalError' in error) {
    return (error as { ngOriginalError?: unknown }).ngOriginalError ?? error;
  }

  return error;
}
